import React from 'react';
import { withSvg } from '../Svg';
const Menu = () => (
  <>
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="currentColor"></path>
  </>
)
export default withSvg(24, 24, true)(Menu);